export default {
  "FoodC_419_gQWM_QlQW": "Apenas em estabelecimentos selecionados",
  "FoodC_419_Gvte_qlpC": "Todos os horários",
  "FoodC_419_zBRR_jLNF": "Sem pedido mínimo",
  "FoodC_419_gCIM_nQek": "Todas as formas de pagamento",
  "FoodC_419_Bzsw_VoVQ": "Todas as cidades",
  "FoodC_419_NGfm_Ulry": "Todos os estabelecimentos",
  "coupon": {
    "other": {
      "time": "Válido até:  {name} ",
      "hide": "Ocultar",
      "cost": "Aplicável para  {name} ",
      "min": "acima de  {name} ",
      "show": "Mais informações",
      "cardBin": "Disponível apenas se o compartimento do cartão for  {name} ",
      "limit": "{name} ",
      "new": "Somente para novo cliente",
      "max": "Desconto máximo de  {name} ",
      "off": "OFF",
      "limitUse": "Somente para  {name} ",
      "use": "Disponível em  {name} "
    },
    "costType": {
      "order": "Pedido",
      "delivery": "Taxa de entrega",
      "meals": "Preço do prato"
    },
    "useRuleWeekDay": {
      "Monday": "Segunda-feira",
      "Thursday": "Quinta-feira",
      "Saturday": "Sábado",
      "Tuesday": "Terça-feira",
      "Sunday": "Domingo",
      "Friday": "Sexta-feira",
      "Wednesday": "Quarta-feira"
    },
    "payTypeList": {
      "all": "Todos os tipos de pagamento",
      "card": "Cartão",
      "pay": "99Pay - Saldo",
      "pos": "Maquininha",
      "money": "Em dinheiro"
    }
  }
}